/**
 * Torso outfit textures: alien-mythic-3
 */
export function drawTorso_radiation_male(ctx, size, options = {}) {
  const mainColor = options.shirtColor;
  // 49. ÁO BẢO HỘ QUANG NĂNG VIỀN PHẢN QUANG (RADIA-66 - MALE)
  ctx.fillStyle = mainColor || '#4d7c0f';
  ctx.fillRect(0, 0, size, size);

  // Dải nẹp phản quang chữ X vàng chanh
  ctx.strokeStyle = '#facc15';
  ctx.lineWidth = size * 0.03;
  ctx.beginPath();
  ctx.moveTo(size * 0.2, size * 0.15);
  ctx.lineTo(size * 0.8, size * 0.65);
  ctx.moveTo(size * 0.8, size * 0.15);
  ctx.lineTo(size * 0.2, size * 0.65);
  ctx.stroke();

  // Lõi hấp thụ bức xạ tròn trung tâm
  ctx.fillStyle = '#a3e635';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.4, size * 0.07, 0, Math.PI * 2);
  ctx.fill();
  ctx.fillStyle = '#1c1917';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.4, size * 0.03, 0, Math.PI * 2);
  ctx.fill();

  // Đai cao su chống phóng xạ
  ctx.fillStyle = '#14532d';
  ctx.fillRect(0, size * 0.68, size, size * 0.1);
}

export function drawTorso_radiation_female(ctx, size, options = {}) {
  // 50. ÁO CHOÀNG CÁCH LY BỨC XẠ THANH LỊCH (RADIA-66 - FEMALE)
  const radFGrad = ctx.createLinearGradient(0, 0, 0, size);
  radFGrad.addColorStop(0, '#365314');
  radFGrad.addColorStop(0.5, '#4d7c0f');
  radFGrad.addColorStop(1, '#65a30d');
  ctx.fillStyle = radFGrad;
  ctx.fillRect(0, 0, size, size);

  // Cổ áo cao bảo hộ
  ctx.fillStyle = options.skinColor || '#a3e635';
  ctx.beginPath();
  ctx.moveTo(size * 0.35, 0);
  ctx.lineTo(size * 0.5, size * 0.15);
  ctx.lineTo(size * 0.65, 0);
  ctx.closePath();
  ctx.fill();

  // Viền dạ quang xanh cốm
  ctx.strokeStyle = '#bef264';
  ctx.lineWidth = size * 0.015;
  ctx.strokeRect(size * 0.15, size * 0.15, size * 0.7, size * 0.5);

  // Đai thắt lưng
  ctx.fillStyle = '#1e3a1e';
  ctx.fillRect(0, size * 0.65, size, size * 0.08);
  ctx.fillStyle = '#facc15';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.69, size * 0.035, 0, Math.PI * 2);
  ctx.fill();
}

export function drawTorso_graviton_male(ctx, size, options = {}) {
  const mainColor = options.shirtColor;
  // 51. BỘ GIÁP BÙ ÁP SUẤT SIÊU TRỌNG LỰC NẸP ĐAI CHỐNG NÉN (BARO-PRIME - MALE)
  ctx.fillStyle = mainColor || '#44403c';
  ctx.fillRect(0, 0, size, size);

  // Mảng giáp nẹp chống nén 50G
  ctx.fillStyle = '#292524';
  ctx.fillRect(size * 0.15, size * 0.15, size * 0.7, size * 0.22);
  ctx.fillRect(size * 0.15, size * 0.42, size * 0.7, size * 0.22);

  // Vòng đệm điều hòa trọng lực ở ngực
  ctx.strokeStyle = '#f59e0b';
  ctx.lineWidth = size * 0.02;
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.26, size * 0.06, 0, Math.PI * 2);
  ctx.stroke();

  // Đai giáp nặng bản to
  ctx.fillStyle = '#1c1917';
  ctx.fillRect(0, size * 0.68, size, size * 0.12);
  ctx.fillStyle = '#78716c';
  ctx.fillRect(size * 0.4, size * 0.7, size * 0.2, size * 0.08);
}

export function drawTorso_graviton_female(ctx, size, options = {}) {
  const mainColor = options.shirtColor;
  // 52. ÁO CHOÀNG TRỌNG LỰC HỌC GIẢ THANH THOÁT (BARO-PRIME - FEMALE)
  ctx.fillStyle = mainColor || '#57534e';
  ctx.fillRect(0, 0, size, size);

  // Cổ áo vuông
  ctx.fillStyle = options.skinColor || '#78716c';
  ctx.fillRect(size * 0.35, 0, size * 0.3, size * 0.15);

  // Các đường vân trường hấp dẫn chìm
  ctx.strokeStyle = 'rgba(214, 211, 209, 0.5)';
  ctx.lineWidth = size * 0.015;
  [0.28, 0.42, 0.56].forEach((yPos) => {
    ctx.beginPath();
    ctx.arc(size * 0.5, size * yPos, size * 0.25, 0, Math.PI);
    ctx.stroke();
  });

  // Đai eo
  ctx.fillStyle = '#292524';
  ctx.fillRect(0, size * 0.65, size, size * 0.08);
  ctx.fillStyle = '#d6d3d1';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.69, size * 0.035, 0, Math.PI * 2);
  ctx.fill();
}

export function drawTorso_chrono_male(ctx, size, options = {}) {
  const mainColor = options.shirtColor;
  // 53. ÁO TU SĨ THỜI GIAN VẠT THÊU CON LẮC VÀ QUỸ ĐẠO (CHRONOPOLIS - MALE)
  ctx.fillStyle = mainColor || '#ca8a04';
  ctx.fillRect(0, 0, size, size);

  // Cổ áo chữ V vạt thêu
  ctx.fillStyle = options.skinColor || '#fde047';
  ctx.beginPath();
  ctx.moveTo(size * 0.34, 0);
  ctx.lineTo(size * 0.5, size * 0.18);
  ctx.lineTo(size * 0.66, 0);
  ctx.closePath();
  ctx.fill();

  // Nẹp viền thêu kim chỉ vàng
  ctx.strokeStyle = '#fef08a';
  ctx.lineWidth = size * 0.02;
  ctx.beginPath();
  ctx.moveTo(size * 0.34, 0);
  ctx.lineTo(size * 0.5, size * 0.18);
  ctx.lineTo(size * 0.5, size * 0.66);
  ctx.stroke();

  // Con lắc đồng hồ ở ngực
  ctx.fillStyle = '#fde047';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.38, size * 0.05, 0, Math.PI * 2);
  ctx.fill();
  ctx.strokeStyle = '#a16207';
  ctx.lineWidth = size * 0.012;
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.38, size * 0.08, 0, Math.PI * 2);
  ctx.stroke();

  // Đai thắt lưng biên niên sử
  ctx.fillStyle = '#713f12';
  ctx.fillRect(0, size * 0.66, size, size * 0.1);
  ctx.fillStyle = '#fef08a';
  ctx.fillRect(size * 0.42, size * 0.67, size * 0.16, size * 0.08);
}

export function drawTorso_chrono_female(ctx, size, options = {}) {
  // 54. VÁY DẠ HỘI DÒNG THỜI GIAN CÁT VÀNG UỐN LƯỢN (CHRONOPOLIS - FEMALE)
  const chrFGrad = ctx.createLinearGradient(0, 0, 0, size);
  chrFGrad.addColorStop(0, '#854d0e');
  chrFGrad.addColorStop(0.5, '#ca8a04');
  chrFGrad.addColorStop(1, '#fde047');
  ctx.fillStyle = chrFGrad;
  ctx.fillRect(0, 0, size, size);

  // Cổ áo vát cánh sen thời gian
  ctx.fillStyle = options.skinColor || '#fde047';
  ctx.beginPath();
  ctx.ellipse(size * 0.5, 0, size * 0.22, size * 0.15, 0, 0, Math.PI);
  ctx.fill();

  // Dải sóng cát vàng uốn lượn
  ctx.strokeStyle = '#fef08a';
  ctx.lineWidth = size * 0.016;
  [0.26, 0.42, 0.56].forEach((yPos) => {
    ctx.beginPath();
    ctx.moveTo(size * 0.18, size * yPos);
    ctx.quadraticCurveTo(size * 0.5, size * (yPos - 0.04), size * 0.82, size * yPos);
    ctx.stroke();
  });

  // Đai thắt lưng ngọc thời không
  ctx.fillStyle = '#713f12';
  ctx.fillRect(0, size * 0.64, size, size * 0.08);
  ctx.fillStyle = '#fde047';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.68, size * 0.04, 0, Math.PI * 2);
  ctx.fill();
}

export function drawTorso_nebula_male(ctx, size, options = {}) {
  const mainColor = options.shirtColor;
  // 55. ÁO LỤA VŨ TRỤ THÊU DẢI PLASMA TINH VÂN (NEBULA-PRIME - MALE)
  ctx.fillStyle = mainColor || '#9333ea';
  ctx.fillRect(0, 0, size, size);

  // Cổ áo chữ V để lộ da tím phớt
  ctx.fillStyle = options.skinColor || '#c084fc';
  ctx.beginPath();
  ctx.moveTo(size * 0.35, 0);
  ctx.lineTo(size * 0.5, size * 0.16);
  ctx.lineTo(size * 0.65, 0);
  ctx.closePath();
  ctx.fill();

  // Dải mây plasma vắt chéo ngực
  const nebMGrad = ctx.createLinearGradient(size * 0.2, size * 0.2, size * 0.8, size * 0.6);
  nebMGrad.addColorStop(0, 'rgba(232, 121, 249, 0.7)');
  nebMGrad.addColorStop(1, 'rgba(192, 132, 252, 0.3)');
  ctx.fillStyle = nebMGrad;
  ctx.beginPath();
  ctx.moveTo(size * 0.2, size * 0.2);
  ctx.quadraticCurveTo(size * 0.5, size * 0.4, size * 0.8, size * 0.5);
  ctx.quadraticCurveTo(size * 0.5, size * 0.5, size * 0.2, size * 0.3);
  ctx.closePath();
  ctx.fill();

  // Điểm hạt bụi sao vàng trắng
  [
    [0.35, 0.28],
    [0.55, 0.38],
    [0.68, 0.45]
  ].forEach((pt) => {
    ctx.fillStyle = '#ffffff';
    ctx.beginPath();
    ctx.arc(size * pt[0], size * pt[1], 2.5, 0, Math.PI * 2);
    ctx.fill();
  });

  // Đai thắt lưng tinh tú
  ctx.fillStyle = '#581c87';
  ctx.fillRect(0, size * 0.66, size, size * 0.08);
  ctx.fillStyle = '#f0abfc';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.7, size * 0.035, 0, Math.PI * 2);
  ctx.fill();
}

export function drawTorso_nebula_female(ctx, size, options = {}) {
  // 56. VÁY DẠ HỘI NGÂN HÀ CHUYỂN SẮC HUYỀN ẢO (NEBULA-PRIME - FEMALE)
  const nebFGrad = ctx.createLinearGradient(0, 0, 0, size);
  nebFGrad.addColorStop(0, '#7e22ce');
  nebFGrad.addColorStop(0.5, '#9333ea');
  nebFGrad.addColorStop(1, '#a855f7');
  ctx.fillStyle = nebFGrad;
  ctx.fillRect(0, 0, size, size);

  // Cổ áo giọt nước mềm mại
  ctx.fillStyle = options.skinColor || '#c084fc';
  ctx.beginPath();
  ctx.ellipse(size * 0.5, 0, size * 0.2, size * 0.14, 0, 0, Math.PI);
  ctx.fill();

  // Dải lụa sóng tinh vân lượn sóng
  ctx.strokeStyle = '#f5d0fe';
  ctx.lineWidth = size * 0.018;
  [0.25, 0.4, 0.55].forEach((yPos) => {
    ctx.beginPath();
    ctx.moveTo(size * 0.15, size * yPos);
    ctx.bezierCurveTo(size * 0.4, size * (yPos - 0.05), size * 0.6, size * (yPos + 0.05), size * 0.85, size * yPos);
    ctx.stroke();
  });

  // Đai eo ngọc tinh vân
  ctx.fillStyle = '#3b0764';
  ctx.fillRect(0, size * 0.65, size, size * 0.08);
  ctx.fillStyle = '#e879f9';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.69, size * 0.04, 0, Math.PI * 2);
  ctx.fill();
}

export function drawTorso_void_male(ctx, size, options = {}) {
  const mainColor = options.shirtColor;
  // 57. ÁO CHOÀNG BÓNG ĐÊM CHÂN KHÔNG TỐI GIẢN (UMBRA-9 - MALE)
  ctx.fillStyle = mainColor || '#0f172a';
  ctx.fillRect(0, 0, size, size);

  // Cổ áo cao chữ V viền titan
  ctx.fillStyle = options.skinColor || '#475569';
  ctx.beginPath();
  ctx.moveTo(size * 0.36, 0);
  ctx.lineTo(size * 0.5, size * 0.18);
  ctx.lineTo(size * 0.64, 0);
  ctx.closePath();
  ctx.fill();

  // Nẹp viền áo xám titan đối xứng
  ctx.strokeStyle = '#334155';
  ctx.lineWidth = size * 0.025;
  ctx.strokeRect(size * 0.2, size * 0.18, size * 0.6, size * 0.48);

  // Biểu tượng hư không hình thoi trung tâm ngực
  ctx.strokeStyle = '#94a3b8';
  ctx.lineWidth = size * 0.015;
  ctx.beginPath();
  ctx.moveTo(size * 0.5, size * 0.32);
  ctx.lineTo(size * 0.58, size * 0.42);
  ctx.lineTo(size * 0.5, size * 0.52);
  ctx.lineTo(size * 0.42, size * 0.42);
  ctx.closePath();
  ctx.stroke();

  // Đai thắt lưng bóng đêm
  ctx.fillStyle = '#020617';
  ctx.fillRect(0, size * 0.68, size, size * 0.1);
  ctx.fillStyle = '#64748b';
  ctx.fillRect(size * 0.42, size * 0.69, size * 0.16, size * 0.08);
}

export function drawTorso_void_female(ctx, size, options = {}) {
  // 58. VÁY DẠ HỘI CHÂN KHÔNG HUYỀN BÍ (UMBRA-9 - FEMALE)
  const voidFGrad = ctx.createLinearGradient(0, 0, 0, size);
  voidFGrad.addColorStop(0, '#1e293b');
  voidFGrad.addColorStop(0.5, '#0f172a');
  voidFGrad.addColorStop(1, '#020617');
  ctx.fillStyle = voidFGrad;
  ctx.fillRect(0, 0, size, size);

  // Cổ áo chữ V thanh nhã
  ctx.fillStyle = options.skinColor || '#475569';
  ctx.beginPath();
  ctx.moveTo(size * 0.34, 0);
  ctx.lineTo(size * 0.5, size * 0.2);
  ctx.lineTo(size * 0.66, 0);
  ctx.closePath();
  ctx.fill();

  // Dải chỉ sáng lượng tử dọc thân áo
  ctx.strokeStyle = 'rgba(148, 163, 184, 0.4)';
  ctx.lineWidth = size * 0.012;
  [0.32, 0.5, 0.68].forEach((xPos) => {
    ctx.beginPath();
    ctx.moveTo(size * xPos, size * 0.22);
    ctx.lineTo(size * xPos, size * 0.64);
    ctx.stroke();
  });

  // Điểm đốm photon lượng tử mờ
  [
    [0.32, 0.35],
    [0.5, 0.45],
    [0.68, 0.38]
  ].forEach((pt) => {
    ctx.fillStyle = '#93c5fd';
    ctx.beginPath();
    ctx.arc(size * pt[0], size * pt[1], 2, 0, Math.PI * 2);
    ctx.fill();
  });

  // Đai eo
  ctx.fillStyle = '#020617';
  ctx.fillRect(0, size * 0.64, size, size * 0.08);
  ctx.fillStyle = '#94a3b8';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.68, size * 0.035, 0, Math.PI * 2);
  ctx.fill();
}

export function drawTorso_singularity_male(ctx, size, options = {}) {
  const mainColor = options.shirtColor;
  // 59. ÁO NHÀ VẬT LÝ CHÂN TRỜI SỰ KIỆN NẸP BỒI TỤ QUANG NĂNG (SINGULARIS - MALE)
  ctx.fillStyle = mainColor || '#0f172a';
  ctx.fillRect(0, 0, size, size);

  // Cổ áo đứng công nghệ cao
  ctx.fillStyle = options.skinColor || '#f1f5f9';
  ctx.beginPath();
  ctx.moveTo(size * 0.35, 0);
  ctx.lineTo(size * 0.5, size * 0.16);
  ctx.lineTo(size * 0.65, 0);
  ctx.closePath();
  ctx.fill();

  // Đĩa bồi tụ quang sai hố đen trước ngực
  ctx.strokeStyle = '#3b82f6';
  ctx.lineWidth = size * 0.022;
  ctx.beginPath();
  ctx.ellipse(size * 0.5, size * 0.38, size * 0.22, size * 0.1, Math.PI * -0.15, 0, Math.PI * 2);
  ctx.stroke();

  ctx.strokeStyle = '#facc15';
  ctx.lineWidth = size * 0.015;
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.38, size * 0.06, 0, Math.PI * 2);
  ctx.stroke();

  ctx.fillStyle = '#020617';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.38, size * 0.03, 0, Math.PI * 2);
  ctx.fill();

  // Đai thắt lưng nẹp bạc
  ctx.fillStyle = '#1e293b';
  ctx.fillRect(0, size * 0.66, size, size * 0.1);
  ctx.fillStyle = '#e2e8f0';
  ctx.fillRect(size * 0.4, size * 0.67, size * 0.2, size * 0.08);
}

export function drawTorso_singularity_female(ctx, size, options = {}) {
  // 60. ÁO CHOÀNG LƯỢNG TỬ TỐI CAO THÊU XOÁY QUANG SAI (SINGULARIS - FEMALE)
  const sinFGrad = ctx.createLinearGradient(0, 0, 0, size);
  sinFGrad.addColorStop(0, '#1d4ed8');
  sinFGrad.addColorStop(0.5, '#2563eb');
  sinFGrad.addColorStop(1, '#1e3a8a');
  ctx.fillStyle = sinFGrad;
  ctx.fillRect(0, 0, size, size);

  // Cổ áo cánh sen viền bạc
  ctx.fillStyle = options.skinColor || '#f1f5f9';
  ctx.beginPath();
  ctx.ellipse(size * 0.5, 0, size * 0.22, size * 0.14, 0, 0, Math.PI);
  ctx.fill();

  // Họa tiết xoáy không thời gian bẻ cong ánh sáng
  ctx.strokeStyle = '#93c5fd';
  ctx.lineWidth = size * 0.018;
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.38, size * 0.16, 0, Math.PI * 1.5);
  ctx.stroke();
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.38, size * 0.08, Math.PI * 0.5, Math.PI * 2);
  ctx.stroke();

  // Đai thắt lưng ánh bạc
  ctx.fillStyle = '#0f172a';
  ctx.fillRect(0, size * 0.64, size, size * 0.08);
  ctx.fillStyle = '#60a5fa';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.68, size * 0.038, 0, Math.PI * 2);
  ctx.fill();
}

export const alien_mythic_3_drawers = {
  radiation_male: drawTorso_radiation_male,
  radiation_female: drawTorso_radiation_female,
  graviton_male: drawTorso_graviton_male,
  graviton_female: drawTorso_graviton_female,
  chrono_male: drawTorso_chrono_male,
  chrono_female: drawTorso_chrono_female,
  nebula_male: drawTorso_nebula_male,
  nebula_female: drawTorso_nebula_female,
  void_male: drawTorso_void_male,
  void_female: drawTorso_void_female,
  singularity_male: drawTorso_singularity_male,
  singularity_female: drawTorso_singularity_female
};
